import { render, staticRenderFns } from "./CoursesAndBookgroups.vue?vue&type=template&id=05deb4d6&scoped=true"
import script from "./CoursesAndBookgroups.vue?vue&type=script&lang=js"
export * from "./CoursesAndBookgroups.vue?vue&type=script&lang=js"
import style0 from "./CoursesAndBookgroups.vue?vue&type=style&index=0&id=05deb4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05deb4d6",
  null
  
)

export default component.exports